import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const MegaMenu = ({ content }) => {
  const { t } = useTranslation();

  if (!content) return null;

  return (
    <Box sx={{ p: 3, minWidth: { md: 600, lg: 750 }, backgroundColor: '#FCF9F3' }}>
      <Grid container spacing={3}>
        {/* Featured Item Section */}
        <Grid item xs={12} md={5}>
          <Box
            sx={{
              position: 'relative',
              height: '100%',
              minHeight: 250,
              borderRadius: '4px',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end',
              p: 2.5,
              color: 'white',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0, left: 0, right: 0, bottom: 0,
                backgroundImage: `url(${content.featured.image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                transition: 'transform 0.4s ease-in-out',
              },
              '&::after': { // Gradient overlay for text readability
                content: '""',
                position: 'absolute',
                top: 0, left: 0, right: 0, bottom: 0,
                background: 'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 60%)',
              },
              '&:hover::before': {
                transform: 'scale(1.05)',
              },
            }}
          >
            <Box sx={{ position: 'relative', zIndex: 1 }}>
              <Typography variant="h6" component="h3" fontWeight="700">
                {t(`${content.featured.key}_title`)}
              </Typography>
              <Typography variant="body2" sx={{ my: 1 }}>
                {t(`${content.featured.key}_desc`)}
              </Typography>
              <Button
                variant="outlined"
                size="small"
                endIcon={<ArrowForwardIcon />}
                sx={{
                  color: 'white',
                  borderColor: 'rgba(255,255,255,0.7)',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    borderColor: 'white',
                  },
                }}
              >
                {t('common_explore')}
              </Button>
            </Box>
          </Box>
        </Grid>

        {/* Links Section */}
        <Grid item xs={12} md={7}>
          <Grid container spacing={3}>
            {content.links.map((column) => (
              <Grid item xs={6} key={column.key}>
                <Typography
                  variant="subtitle1"
                  fontWeight="700"
                  sx={{ color: '#2E3836', mb: 1.5, borderBottom: '2px solid #D4A259', pb: 0.5, display: 'inline-block' }}
                >
                  {t(column.key)}
                </Typography>
                <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
                  {column.items.map((itemKey) => (
                    <Box component="li" key={itemKey} sx={{ p: 0 }}>
                      <Link
                        href="/destinations"
                        underline="none"
                        sx={{
                          display: 'block',
                          py: 0.75,
                          color: '#586462',
                          fontFamily: "'Lato', sans-serif",
                          transition: 'all 0.2s ease',
                          '&:hover': {
                            color: '#D4A259',
                            transform: 'translateX(5px)',
                          },
                        }}
                      >
                        {t(itemKey)}
                      </Link>
                    </Box>
                  ))}
                </Box>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MegaMenu;